// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  position: relative;
}
:host .avatar {
  position: relative;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 1px solid #AEB1B9;
  box-shadow: 0 0 0 12px rgba(228, 229, 232, 0.5);
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
:host .avatar.frontline {
  border: 1px solid #1785FB;
}
:host .avatar .photo {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-size: contain;
  z-index: 1;
}
:host .avatar .initials {
  font-weight: 300;
  font-family: "RM Neue";
  font-size: 24px;
  line-height: 24px;
  z-index: 0;
}
:host .avatar svg {
  position: absolute;
  top: -13px;
  left: -13px;
  z-index: 1;
}
:host .avatar svg path.arc {
  fill: none;
  stroke-width: 12px;
  stroke: #3E31FA;
  stroke-dasharray: 0 226;
  opacity: 1;
  transition: stroke-dasharray 1s ease-out, opacity 0.5s ease-out;
}
:host .avatar svg path.arc.best {
  stroke-dasharray: none !important;
}
:host .avatar svg path.arc.reset {
  transition-duration: 0.5s, 0.5s;
  opacity: 0;
}
:host .avatar svg #textPath {
  stroke: none;
  fill: none;
}
:host .avatar svg .text {
  text-anchor: middle;
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  margin-bottom: 2px;
  fill: #FFF;
}
:host .name {
  width: 112px;
  margin-top: 16px;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 11px;
  line-height: 11px;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1A1E29;
}
:host .name .number {
  font-weight: 700;
  font-family: "RM Neue";
}
:host .faults {
  margin-top: 6px;
  position: relative;
  align-self: stretch;
  display: flex;
  justify-content: center;
}
:host .faults .progressbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 18px;
  width: 58px;
  padding: 0 3px;
  border-radius: 2px;
  background-color: #F2F2F4;
}
:host .faults .progressbar .ball {
  flex: 0 0 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #C9CBD1;
}
:host .faults .progressbar .ball.full {
  background-color: #E73F74;
}
:host .faults .frontline {
  height: 16px;
  position: absolute;
  top: 0;
  right: 6px;
}
:host .value {
  margin-top: 12px;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  color: #1A1E29;
}
:host .value .unit {
  display: block;
  margin-top: 8px;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #787D8B;
}`, "",{"version":3,"sources":["webpack://./src/app/stats/player-badge/player-badge.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AADF;AAGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,+CAAA;EACA,sBCES;EDDT,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAII;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;AAFN;AAKI;ECoBA,gBAAA;EAYA,sBAAA;ED9BE,eAAA;EACA,iBAAA;EACA,UAAA;AAFN;AAKI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAHN;AAKM;EACE,UAAA;EACA,kBAAA;EACA,eCrDO;EDsDP,uBAAA;EAGA,UAAA;EACA,+DAAA;AALR;AAQQ;EACE,iCAAA;AANV;AASQ;EACE,+BAAA;EACA,UAAA;AAPV;AAWM;EACE,YAAA;EACA,UAAA;AATR;AAYM;EACE,mBAAA;ECdJ,gBAAA;EAQA,+DAAA;EDQI,eAAA;EACA,iBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,UClEK;ADwDb;AAiBE;EACE,YAAA;EACA,gBAAA;EClCA,gBAAA;EAUA,sBAAA;ED0BA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cChGQ;ADkFZ;AAgBI;EC1CA,gBAAA;EAMA,sBAAA;ADwBJ;AAiBE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAfJ;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBC5GK;AD6FX;AAiBM;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBCpHG;ADqGX;AAiBQ;EACE,yBCvGC;ADwFX;AAoBI;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAlBN;AAsBE;EACE,gBAAA;ECzFA,gBAAA;EAUA,sBAAA;EDiFA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cClJQ;AD+HZ;AAqBI;EACE,cAAA;EACA,eAAA;EClGF,gBAAA;EAUA,sBAAA;ED0FE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cCvJK;ADqIX","sourcesContent":["@import 'theme';\n\n:host {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0;\n  position: relative;\n\n  .avatar {\n    position: relative;\n    height: 60px;\n    width: 60px;\n    border-radius: 50%;\n    border: 1px solid $colorN30;\n    box-shadow: 0 0 0 12px transparentize($colorN10, .5);\n    background-color: $colorWhite;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    &.frontline {\n      border: 1px solid $colorAccent;\n    }\n\n    .photo {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      border-radius: 50%;\n      background-size: contain;\n      z-index: 1;\n    }\n\n    .initials {\n      @include font(light, condensed);\n      font-size: 24px;\n      line-height: 24px;\n      z-index: 0;\n    }\n\n    svg {\n      position: absolute;\n      top: -13px;\n      left: -13px;\n      z-index: 1;\n\n      path.arc {\n        fill: none;\n        stroke-width: 12px;\n        stroke: $colorPrimary;\n        stroke-dasharray: 0 226;\n        // transform: rotateZ(90deg);\n        // transform-origin: center;\n        opacity: 1;\n        transition: stroke-dasharray $animationTimeNormal $animationFuncDefault,\n                    opacity $animationTimeFast $animationFuncDefault;\n\n        &.best {\n          stroke-dasharray: none !important;\n        }\n\n        &.reset {\n          transition-duration: $animationTimeFast, $animationTimeFast;\n          opacity: 0;\n        }\n      }\n\n      #textPath {\n        stroke: none;\n        fill: none;\n      }\n\n      .text {\n        text-anchor: middle;\n        @include font(bold);\n        font-size: 10px;\n        line-height: 12px;\n        text-transform: uppercase;\n        // letter-spacing: 1px;\n        margin-bottom: 2px;\n        fill: $colorWhite;\n        // transform: rotateZ(-90deg);\n        // transform-origin: center;\n      }\n    }\n  }\n\n  .name {\n    width: 112px;\n    margin-top: 16px;\n    @include font(normal, condensed);\n    font-size: 11px;\n    line-height: 11px;\n    letter-spacing: 1px;\n    text-align: center;\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: $colorN100;\n\n    .number {\n      @include font(bold, condensed);\n    }\n  }\n\n  .faults {\n    margin-top: 6px;\n    position: relative;\n    align-self: stretch;\n    display: flex;\n    justify-content: center;\n\n    .progressbar {\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n      height: 18px;\n      width: 58px;\n      padding: 0 3px;\n      border-radius: 2px;\n      background-color: $colorN05;\n\n      .ball {\n        flex: 0 0 6px;\n        height: 6px;\n        border-radius: 50%;\n        background-color: $colorN20;\n\n        &.full {\n          background-color: $colorBad;\n        }\n      }\n    }\n\n    .frontline {\n      height: 16px;\n      position: absolute;\n      top: 0;\n      right: 6px;\n    }\n  }\n\n  .value {\n    margin-top: 12px;\n    @include font(normal, condensed);\n    font-size: 20px;\n    line-height: 20px;\n    text-align: center;\n    color: $colorN100;\n\n    .unit {\n      display: block;\n      margin-top: 8px;\n      @include font(normal, condensed);\n      font-size: 10px;\n      line-height: 10px;\n      letter-spacing: 1px;\n      text-transform: uppercase;\n      color: $colorN50;\n    }\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
